import { logError } from '@helpers/Loggers';

export async function allFulfilled<T>(promises: Promise<T>[]) {
  const settled = await Promise.allSettled(promises);
  const results: Awaited<T>[] = [];
  for (const promise of settled) {
    if (promise.status === 'fulfilled') {
      results.push(promise.value);
    } else {
      if (promise.reason instanceof Error) {
        logError(promise.reason);
      } else {
        logError(new Error('Promise rejected: ' + promise.reason));
      }
    }
  }
  return results;
}
